import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import { Send } from 'react-feather';
import { desktop, useIsMobile } from '../../../style/constants';
import { Input } from '../../../VuexyDesign/atoms/_index';
import UserImage from '../../common/UserImage';
import { ProfileLink } from '../../common/Link';
import { useCurrentUser } from '../../../api';
import CentralizeButton from '../../../VuexyDesign/atoms/CentralizeButton';

const CommentForm = ({ onSend }: { onSend: (comment: string) => void }) => {
  const { t } = useTranslation('tracks');
  const { query } = useRouter();
  const [comment, setComment] = useState('');
  const [focus, setFocus] = useState(false);
  const user = useCurrentUser();
  const isMobile = useIsMobile();

  const send = () => {
    onSend(comment);
    setComment('');
  };

  useEffect(() => {
    if (!focus) {
      if (query && query.comment) {
        const textArea = document.querySelector(
          '#textArea',
        ) as HTMLInputElement;
        if (textArea) {
          setFocus(true);
          textArea.scrollIntoView(false);
          window.scrollBy(0, 100);
          textArea.focus();
        }
      }
    }
  }, [focus, query]);

  return (
    <Wrapper>
      <div className="d-flex w-100 align-items-center commentInput">
        <ProfileLink profileId={user.id}>
          <UserImage src={user.profile_photo} size={30} />
        </ProfileLink>
        <Input
          id="textArea"
          name="live-comment"
          placeholder={t('tracks:writeAComment') as string}
          className="text-dark"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setComment(event.target.value);
          }}
          value={comment}
        />
        {isMobile && (
          <CentralizeButton
            onClick={send}
            color="primary"
            className="postbtn btn-icon"
            icon={Send}
            iconSize="14"
            isIconLeftSide
            size="sm"
          />
        )}
      </div>
      {!isMobile && (
        <CentralizeButton
          onClick={send}
          text={t('tracks:postComment') as string}
          color="primary"
          className="postbtn"
          icon={Send}
          iconSize="14"
          isIconLeftSide
          size="sm"
        />
      )}
    </Wrapper>
  );
};

export default CommentForm;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;

  @media ${desktop} {
    flex-direction: row;
  }
  .commentInput {
    gap: 16px;
  }
  .postbtn {
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: auto;
  }
`;
